module.exports = __webpack_public_path__ + "static/img/bbc-benefit1.2318c5e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/promotion/bbc-benefit1.png
// module id = 1070
// module chunks = 1